import type { IOrchestratorUser } from '@experiences/interfaces';
import {
    get,
    getOrchestratorODataRoute,
} from '@experiences/util';

export function getCurrentOrchestratorUser(accessToken: string, accountLogicalName: string, tenantName: string) {
    const url = `${getOrchestratorODataRoute(accountLogicalName, tenantName)}/Users/UiPath.Server.Configuration.OData.GetCurrentUser`;

    return get<IOrchestratorUser>(url, {
        accessToken,
        ignoreBasePath: true,
    });
}
